import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { useToggleBlockToggle } from 'common/Prose/Toolbar/hooks/useToggleBlockToggle'
import { SingleMenuDropdownItem } from '../SingleMenuDropdown/SingleMenuDropdownItem'
import { observer } from 'mobx-react-lite'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'

export const ToggleBlockItem = observer(({ withLabel = false }: { withLabel?: boolean }) => {
  const view = useEditorView()
  const { active, handleClick, disabled } = useToggleBlockToggle(view)
  const label = 'Toggle list'
  const tooltip = withLabel ? undefined : { label }

  return (
    <SingleMenuDropdownItem
      icon={<ToolbarIcon name={IconName.ToggleBlock} />}
      label={withLabel ? label : ''}
      ariaLabel="Turn into toggle block"
      active={active}
      disabled={disabled}
      handleClick={handleClick}
      tooltip={tooltip}
    />
  )
})
